import React from "react";
import "./error-popup.scss";

const ErrorPopUpChildComponent = ({ errorText }) => {
  console.log(errorText);
  return (
    <div className="error-popup-container">
      <span className="error-popup-text">
        {errorText.split("\n").map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
      </span>
    </div>
  );
};

export default ErrorPopUpChildComponent;
